import userApi from '@/api/user'
import { errorHandler } from '../exports/error_management'

const state = {
    all_users: [],
    drivers: [],
    users: [],
    user: {},
    pagination: null,
}

const getters = {
    all_admin_users(state) {
        return state.all_users.filter(x => !x.is_customer_user)
    },
    sorted_officers(state) {
        console.log('state.all_users', state.all_users)
        const officers = state.all_users
            .filter(({ is_customer_user }) => !is_customer_user)
            .map(({ id, first_name, last_name }) => ({
                id,
                name: `${first_name || ''} ${last_name || ''}`.trim(),
            }))
            .filter(x => x.name)
        officers.sort((a, b) => {
            if (a.name.toUpperCase() > b.name.toUpperCase()) {
                return 1
            }
            if (a.name.toUpperCase() < b.name.toUpperCase()) {
                return -1
            }
            return 0
        })
        console.log('officers', officers)
        return officers
    },
    all_customers_users(state) {
        return state.all_users.filter(x => !!x.is_customer_user)
    },
}

const mutations = {
    set_user(state, payload) {
        state.user = payload
    },
    set_users(state, payload) {
        state.users = payload
    },
    set_drivers(state, payload) {
        state.drivers = payload
    },
    set_all_users(state, data) {
        console.log('all users', data)
        state.all_users = data
    },
    delete_user(state, id) {
        let index = state.users.findIndex(x => x.id == id)
        state.users.splice(index, 1)
    },
    set_pagination(state, pag) {
        state.pagination = pag
    },
}

const actions = {
    fetchDrivers(context) {
        return userApi.fetchDriverLocations().then(drivers => {
            console.log('drivers-store', drivers)
            context.commit('set_drivers', drivers)
        })
    },

    fetchAll(context) {
        return userApi.fetchAll().then(results => {
            console.log('users-store', results)
            context.commit('set_all_users', results.data.success.data)
        })
    },

    createUser(context, payload) {
        return userApi
            .create(
                payload.firstName,
                payload.lastName,
                payload.email,
                payload.roles,
                payload.permissions,
                payload.password
            )
            .then(res => {
                console.log('users', res)
            })
            .catch(err => {
                errorHandler(err)
            })
    },

    fetchUser(context, id) {
        console.log('fetchuser id', id)
        return userApi
            .fetchById(id)
            .then(
                ({
                    data: {
                        success: { data: user },
                    },
                }) => {
                    console.log('fetchuser data', user)
                    //const user = data.success.data
                    context.commit('set_user', user)
                }
            )
            .catch(err => {
                errorHandler(err)
            })
    },

    fetchUsers(context, payload) {
        return userApi
            .fetchUsers(payload.query, payload.page)
            .then(
                ({
                    data: {
                        success: { data: pag },
                    },
                }) => {
                    //context.commit('user_update_info', payload)
                    // console.log(result)
                    //console.log(context)
                    //let pag = result.data.success.data
                    let users = pag.data.map(x => {
                        x.firstName = x.first_name
                        x.lastName = x.last_name
                        delete x.first_name
                        delete x.last_name

                        return x
                    })
                    // console.log(users)
                    context.commit('set_users', users)
                    context.commit('set_pagination', {
                        page: pag.current_page,
                        pageSize: pag.per_page,
                        total: pag.total,
                    })
                }
            )
            .catch(err => {
                errorHandler(err)
            })
    },
    async deleteUser(context, id) {
        // Check to see if its hitting this command:
        console.log('Deleting user ...')
        return userApi
            .deleteUser(id)
            .then(() => {
                console.log('user deleted')
                context.commit('delete_user', id)
            })
            .catch(err => {
                console.error(err)
                errorHandler(err)
            })
    },
    updateBasicInfo(context, payload) {
        console.log('payload', payload)
        return userApi
            .updateBasicInfo(payload)
            .then(() => {
                //context.commit('user_update_info', payload)
            })
            .catch(err => {
                errorHandler(err)
            })
    },
    updateEmail(context, payload) {
        return userApi
            .updateEmail(payload.userId, payload.email)
            .then(() => {
                //context.commit('user_update_email', payload)
            })
            .catch(err => {
                errorHandler(err)
            })
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
